module.exports = __webpack_public_path__ + "static/rules-293d7c0bb9f214984b787f611fc79ce8.pdf";